import './styles/index.scss';
import './styles/game_info.scss';
import './styles/meta.scss';
import './assets/decagon.svg';
import './assets/venue.svg';
